import type { ReactNode } from "react";
import { createPortal } from "react-dom";

/**
 * Drop indicators and drag ghosts use viewport coordinates, so they render on
 * <body>: inside the deck a transformed ancestor would offset `position: fixed`.
 */
export function DragLayer({ children }: { children: ReactNode }) {
  return createPortal(children, document.body);
}
